module.exports = __webpack_public_path__ + "img/app-item-dark-mode.bc10330b.svg";